import axios from 'axios';

export const GET_TOPICS = 'cms/topics/';

export function getTopics(params) {
  return axios.get(GET_TOPICS, { params: params });
}
